module.exports = __webpack_public_path__ + "img/ex07.30a2b5f7.png";